module.exports = __webpack_public_path__ + "static/media/github.006879c4.svg";